import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGb = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 60,
	height: 30,
	viewBox: "0 0 60 30",
	"aria-labelledby": "ism-gb-flag",
	role: "img",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", {
			id: "ism-gb-flag",
			children: "English"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("polygon", {
			id: "gb-a",
			points: "0 0 0 30 60 30 60 0"
		}), /* @__PURE__ */ _jsx("path", {
			id: "gb-c",
			d: "M30,15 L60,15 L60,30 L30,15 Z M30,15 L30,30 L0,30 L30,15 Z M30,15 L0,15 L0,0 L30,15 Z M30,15 L30,0 L60,0 L30,15 Z"
		})] }),
		/* @__PURE__ */ _jsxs("g", {
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "gb-b",
				fill: "#fff",
				children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#gb-a" })
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#gb-b)",
				children: [
					/* @__PURE__ */ _jsx("polygon", {
						fill: "#012169",
						fillRule: "nonzero",
						points: "0 0 0 30 60 30 60 0"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#000",
						fillRule: "nonzero",
						stroke: "#FFF",
						strokeWidth: 6,
						d: "M0,0 L60,30 M60,0 L0,30"
					}),
					/* @__PURE__ */ _jsx("mask", {
						id: "gb-d",
						fill: "#fff",
						children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#gb-c" })
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#000",
						fillRule: "nonzero",
						stroke: "#C8102E",
						strokeWidth: 4,
						d: "M0,0 L60,30 M60,0 L0,30",
						mask: "url(#gb-d)"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#000",
						fillRule: "nonzero",
						stroke: "#FFF",
						strokeWidth: 10,
						d: "M30,0 L30,30 M0,15 L60,15"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#000",
						fillRule: "nonzero",
						stroke: "#C8102E",
						strokeWidth: 6,
						d: "M30,0 L30,30 M0,15 L60,15"
					})
				]
			})]
		})
	]
});
export default SvgGb;
